import { render } from "./SubCategory.vue?vue&type=template&id=9b93922e"
import script from "./SubCategory.vue?vue&type=script&lang=js"
export * from "./SubCategory.vue?vue&type=script&lang=js"

import "./SubCategory.vue?vue&type=style&index=0&id=9b93922e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__